"use client";
import { j as u } from "./jsx-runtime-CJ-St4mQ.mjs";
import h from "react";
import { f as A, c as C } from "./Field.style-CQ8CRW6E.mjs";
import v from "./Box.js";
const N = (g) => {
  const { length: o, onChange: n, value: m, separator: w } = g, c = h.useRef(new Array(o).fill(null)), p = (e) => {
    c.current[e].focus();
  }, f = (e) => {
    const a = c.current[e];
    a == null || a.select();
  }, D = (e, a) => {
    switch (e.key) {
      case "ArrowUp":
      case "ArrowDown":
      case " ":
        e.preventDefault();
        break;
      case "ArrowLeft":
        e.preventDefault(), a > 0 && (p(a - 1), f(a - 1));
        break;
      case "ArrowRight":
        e.preventDefault(), a < o - 1 && (p(a + 1), f(a + 1));
        break;
      case "Delete":
        e.preventDefault(), n((t) => t.slice(0, a) + t.slice(a + 1));
        break;
      case "Backspace":
        e.preventDefault(), a > 0 && (p(a - 1), f(a - 1)), n((t) => t.slice(0, a) + t.slice(a + 1));
        break;
    }
  }, b = (e, a) => {
    const t = e.target.value;
    let s = 0;
    for (; s <= a && (c.current[s].value && s < a); )
      s += 1;
    n((l) => {
      const i = l.split(""), r = t[t.length - 1];
      return i[s] = r, i.join("");
    }), t !== "" && a < o - 1 && p(a + 1);
  }, k = (e, a) => {
    f(a);
  }, j = (e, a) => {
    e.preventDefault();
    const t = e.clipboardData;
    if (t.types.includes("text/plain")) {
      let s = t.getData("text/plain");
      s = s.substring(0, o).trim();
      let l = 0;
      for (; l <= a && (c.current[l].value && l < a); )
        l += 1;
      const i = m.split("");
      for (let r = l; r < o; r += 1) {
        const y = s[r - l] ?? " ";
        i[r] = y;
      }
      n(i.join(""));
    }
  };
  return /* @__PURE__ */ u.jsx(v, { flex: !0, alignItems: "center", className: "gap-4", children: new Array(o).fill(null).map((e, a) => /* @__PURE__ */ u.jsxs(h.Fragment, { children: [
    /* @__PURE__ */ u.jsx("div", { className: A({ class: "!w-10" }), children: /* @__PURE__ */ u.jsx(
      "input",
      {
        className: C(),
        "aria-label": `Digit ${a + 1} of OTP`,
        onKeyDown: (t) => D(t, a),
        onChange: (t) => b(t, a),
        onClick: (t) => k(t, a),
        onPaste: (t) => j(t, a),
        value: m[a] ?? "",
        ref: (t) => {
          c.current[a] = t;
        }
      }
    ) }),
    a === o - 1 ? null : w
  ] }, a)) });
};
export {
  N as default
};
